import * as rxjs from "rxjs";

export function subscribeImpl(handlers, observable) {
  return observable.subscribe(handlers);
}

export function unsubscribeImpl(subscription) {
  return subscription.unsubscribe();
}

export function mkReplaySubjectImpl() {
  return new rxjs.ReplaySubject();
}

export function nextImpl(behavior, value) {
  return behavior.next(value);
}

export function errorImpl(behavior, value) {
  return behavior.error(value);
}

export function completeImpl(behavior) {
  return behavior.complete();
}

export function mkObservableImpl(create) {
  return new rxjs.Observable(function (handlers) {
    // Why am I not passing handlers directly, you might ask?
    // Well, rxjs reads the value of "this" in some places,
    // but somehow passing handlers directly loses that value...
    //
    // I spent hours debugging this issue, because it's very subtle
    // and can manifest much later.
    return create({
      next: (v) =>  handlers.next(v),
      error: (v) =>  handlers.error(v),
      complete: () =>  handlers.complete()
    });
  });
}

export function firstValueFromImpl(observable, defaultValue) {
  return rxjs.firstValueFrom(observable, defaultValue);
}

export function lastValueFromImpl(observable, defaultValue) {
  return rxjs.lastValueFrom(observable, defaultValue);
}

export function ofImpl(values) {
  return rxjs.of(...values);
}

export const mapImpl = rxjs.map;
export const filterImpl = rxjs.filter;
export const takeImpl = rxjs.take;
export const takeUntilImpl = rxjs.takeUntil;
export const skipImpl = rxjs.skip;
export const catchErrorImpl = rxjs.catchError;
export const toArrayImpl = rxjs.toArray();
export const shareReplayImpl = rxjs.shareReplay;
export const timeoutImpl = rxjs.timeout;
export const throwErrorImpl = rxjs.throwError
export const concatMapImpl = rxjs.concatMap
export const takeWhileImpl = rxjs.takeWhile
